import { Box, ButtonIcon, IconClear } from '@capitalise/ui-design-system';
import React, { memo } from 'react';
import NavbarLink from '../NavbarLink';
import MenuSection from '../MenuSection';
import PropTypes from 'prop-types';
import useBusinessMenu from 'modules/Business/hooks/useBusinessMenu';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';
import { sidebar } from 'enums/sidebar';

const BusinessSideMenu = ({ onClose }) => {
  const { menuItems } = useBusinessMenu();
  const { isMobile } = useMediaQuery();

  const todayMenus = menuItems.filter((item) => item.group === sidebar.today);
  const analysisMenu = menuItems.filter((item) => item.group === sidebar.analysis);
  const marketplaceMenus = menuItems.filter((item) => item.group === sidebar.marketplace);

  const renderTodayMenus = [
    <>
      {todayMenus.map((navItem) => (
        <NavbarLink
          key={navItem.item.label}
          data-testid={`${navItem.item.label}-sidemenu-link`}
          to={navItem.url}
          label={navItem.item.label}
          icon={navItem.item.icon}
        />
      ))}
    </>,
  ];

  const renderAnalysisMenus = [
    <>
      {analysisMenu.map((navItem) => (
        <NavbarLink
          key={navItem.item.label}
          data-testid={`${navItem.item.label}-sidemenu-link`}
          to={navItem.url}
          label={navItem.item.label}
          icon={navItem.item.icon}
        />
      ))}
    </>,
  ];

  const renderMarketplaceMenus = [
    <>
      {marketplaceMenus.map((navItem) => (
        <NavbarLink
          key={navItem.item.label}
          data-testid={`${navItem.item.label}-sidemenu-link`}
          to={navItem.url}
          label={navItem.item.label}
          icon={navItem.item.icon}
        />
      ))}
    </>,
  ];

  return (
    <>
      {isMobile && (
        <Box display="flex" justifyContent="end" px="4xsmall" pb="4xsmall">
          <ButtonIcon baseColor="grey" onClick={onClose} round size="medium">
            <IconClear />
          </ButtonIcon>
        </Box>
      )}
      <MenuSection showTitle={false} menus={renderTodayMenus} />
      <MenuSection
        title={sidebar.analysis}
        showTitle={analysisMenu.length > 0}
        menus={renderAnalysisMenus}
      />
      <MenuSection
        title={sidebar.marketplace}
        showTitle={marketplaceMenus.length > 0}
        menus={renderMarketplaceMenus}
      />
    </>
  );
};

BusinessSideMenu.propTypes = {
  onClose: PropTypes.func,
};

export default memo(BusinessSideMenu);
